export default __webpack_public_path__ + "static/media/message.e2fb7cb3.svg";